<template>
  <div>
    <b-row>
      <b-col>
        <base-button
          type="default"
          block
          class="mb-3"
          @click="abrirModalFormulario('modal-form-colegio')"
        >
          Crear nuevo Colegio
        </base-button>
        <tabla-gestion-colegios
          nombreColumna="Nombre Colegio"
          :data="colegios"
          @editarElemento="editarColegio"
          @eliminarElemento="eliminarColegio"
        />
      </b-col>
      <b-col>
        <base-button
          type="default"
          block
          class="mb-3"
          @click="abrirModalFormulario('modal-form-curso')"
        >
          Crear nuevo Curso
        </base-button>
        <tabla-gestion-colegios
          nombreColumna="Nombre Curso"
          :data="cursos"
          @editarElemento="editarCurso"
          @eliminarElemento="eliminarCurso"
        />
      </b-col>
    </b-row>
    <modal-colegio
      :idModal="idModal"
      @guarda="guardarDatos"
      :datos="colegioCurso"
    />
  </div>
</template>
<script>
import axios from "@/directives/axios.js";
import tablaGestionColegios from "@/components/Tables/TablaGestionColegios.vue";
import modalColegio from "@/components/modals/ModalColegio.vue";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import "@/components/Spinner-Load/loader.css";
import { spinner } from "@/components/Spinner-Load/loader.js";
const loader = spinner();

export default {
  components: {
    tablaGestionColegios,
    modalColegio,
  },
  props: {},
  data() {
    return {
      idModal: "",
      colegioCurso: { id: undefined, nombre: undefined },
    };
  },
  computed: {
    colegios() {
      if (this.$store.getters.getColegios != undefined) {
        loader.close();
        return this.$store.getters.getColegios;
      } else {
        loader.open();
        this.$store.dispatch("recargaColegiosCursos");
        return [];
      }
    },
    cursos() {
      if (this.$store.getters.getCursosEscolares != undefined) {
        loader.close();
        return this.$store.getters.getCursosEscolares;
      } else {
        loader.open();
        this.$store.dispatch("recargaColegiosCursos");
        return [];
      }
    },
  },
  methods: {
    abrirModalFormulario(id) {
      this.colegioCurso = { id: undefined, nombre: undefined };
      this.idModal = id;
      this.$nextTick(() => {
        this.$bvModal.show(id);
      });
    },
    editarColegio(value) {
      this.colegioCurso = value;
      this.idModal = "modal-form-colegio";
      this.$nextTick(() => {
        this.$bvModal.show("modal-form-colegio");
      });
    },
    editarCurso(value) {
      this.colegioCurso = value;
      this.idModal = "modal-form-curso";
      this.$nextTick(() => {
        this.$bvModal.show("modal-form-curso");
      });
    },
    guardarDatos(value) {
      switch (this.idModal) {
        case "modal-form-colegio":
          this.guardaColegio(value);
          break;
        case "modal-form-curso":
          this.guardaCurso(value);
          break;

        default:
          break;
      }
    },
    guardaColegio(value) {
      loader.open();
      axios({
        method: "post",
        url: `/colegios/editarColegio`,
        withCredentials: true,
        data: value,
      })
        .then((data) => {
          this.$store.dispatch("recargaColegiosCursos", data.data);
          this.$bvModal.hide("modal-form-colegio");
          loader.close();
          swal
            .fire({
              title: `Colegio guardado Correctamente`,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-success",
              icon: "success",
            });
        })
        .catch(() => {
          loader.close();
          swal.fire({
            title: `Error`,
            text: "Ocurrio un error inesperado, intentelo mas tarde",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-warning",
            icon: "warning",
          });
        });
    },
    guardaCurso(value) {
      loader.open();
      axios({
        method: "post",
        url: `/colegios/editarCurso`,
        withCredentials: true,
        data: value,
      })
        .then((data) => {
          this.$store.dispatch("recargaColegiosCursos", data.data);
          this.$bvModal.hide("modal-form-curso");
          loader.close();
          swal
            .fire({
              title: `Curso guardado Correctamente`,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-success",
              icon: "success",
            });
        })
        .catch(() => {
          loader.close();
          swal.fire({
            title: `Error`,
            text: "Ocurrio un error inesperado, intentelo mas tarde",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-warning",
            icon: "warning",
          });
        });
    },
    eliminarColegio(id) {
      loader.open();
      axios({
        method: "delete",
        url: `/colegios/colegio?id=${id}`,
        withCredentials: true,
      })
        .then((data) => {
          this.$store.dispatch("recargaColegiosCursos", data.data);
          loader.close();
          swal
            .fire({
              title: `Colegio eliminado Correctamente`,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-success",
              icon: "success",
            });
        })
        .catch(() => {
          loader.close();
          swal.fire({
            title: `Error`,
            text: "Ocurrio un error inesperado, intentelo mas tarde",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-warning",
            icon: "warning",
          });
        });
    },
    eliminarCurso(id) {
      loader.open();
      axios({
        method: "delete",
        url: `/colegios/cursoEscolar?id=${id}`,
        withCredentials: true,
      })
        .then((data) => {
          this.$store.dispatch("recargaColegiosCursos", data.data);
          loader.close();
          swal
            .fire({
              title: `Curso eliminado Correctamente`,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-success",
              icon: "success",
            });
        })
        .catch(() => {
          loader.close();
          swal.fire({
            title: `Error`,
            text: "Ocurrio un error inesperado, intentelo mas tarde",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-warning",
            icon: "warning",
          });
        });
    },
  },
};
</script>
<style scoped>
.row {
  display: -webkit-box;
}
</style>
